const users = [
    {
        id: 1,
        name: "John Doe",
        email: '',
        password: 'password123'
    },
    {
        id: 2,
        name: "elif",
        email: 'elif@gmail.com',
        password: 'random'
    },
];

export default users;